import http from './index'

export default {
  /*
   * 获取小部件列表
   * */
  list (params) {
    return http.get('/front/widget/list', params)
  },
  /*
   * 添加小部件
   * */
  add (params) {
    return http.post('/front/widget/save', params)
  },
  /*
   * 删除小部件
   * */
  remove (params) {
    return http.post('/front/widget/deletion', params)
  },
  /*
   * 编辑小部件
   * */
  edit (params) {
    return http.post('/front/widget/save', params)
  },
  /*
   * 获取小部件预览数据
   * */
  getData (params) {
    return http.get(`/front/widget/data/${params}`)
  },
  /*
   * 获取组件类型
   * */
  getServiceType (params) {
    return http.get('/front/widget/serviceType', params)
  }
}
